import { render, staticRenderFns } from "./dialogControl.vue?vue&type=template&id=3884c966&scoped=true"
import script from "./dialogControl.vue?vue&type=script&lang=js"
export * from "./dialogControl.vue?vue&type=script&lang=js"
import style0 from "./dialogControl.vue?vue&type=style&index=0&id=3884c966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884c966",
  null
  
)

export default component.exports